<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="th-large"
    :items="filteredProfessionGroups"
    :loading="loading"
    @search="onSearch"
    @focus="onFocus"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { useProfessionGroup } from "~/components/_refactored/conductor/professionGroups/useProfessionGroup";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: null,
    },
  },
  setup(_props, { emit }) {
    const { getProfessionGroups } = useProfessionGroup();
    const filteredProfessionGroups = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      loading.value = true;
      const { items } = await getProfessionGroups({
        search,
        page: 1,
        pageSize: 15,
      });
      filteredProfessionGroups.value = items;
      loading.value = false;
    };

    const onFocus = (search) => {
      onSearch(search ?? "");
      emit("focus", search);
    };

    return {
      filteredProfessionGroups,
      onSearch,
      onFocus,
      loading,
    };
  },
};
</script>
